import { Component, OnInit } from '@angular/core';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';

@Component({
  selector: 'app-home-footer',
  templateUrl: './home-footer.component.html',
  styleUrls: ['./home-footer.component.scss']
})
export class HomeFooterComponent implements OnInit {

  // footerData = [
  //   { 'no': 1, 'url': '/feedback', 'text': 'Feedback' },
  //   { 'no': 2, 'url': '/repairprice', 'text': 'RepairPrice' },
  //   { 'no': 3, 'url': '/scheduling', 'text': 'Scheduling' },
  //   { 'no': 4, 'url': '/invoicing', 'text': 'Invoicing' },
  //   { 'no': 5, 'url':'/add_value','text':'Add/Deduct Value'},
  //   { 'no': 6, 'url': '/show_score', 'text': 'Add Stars' },
  //   { 'no': 7, 'url': '/admins-ips', 'text': 'Ip Address' },
  //   { 'no': 8, 'url': '/inventory', 'text': 'Inventory' },
  //   { 'no': 9, 'url': '/repair', 'text': 'Repair Process' },
  //   { 'no': 10, 'url': '/add-product', 'text': 'Add Product' },
  //   { 'no': 11, 'url': '/home-mass', 'text': 'Search' },
  //   { 'no': 12, 'url': '/search2', 'text': 'Search2' },
  //   { 'no': 13, 'url':'/add-client','text':'Client'},
  // ];
  footerDataUpper = [
    { 'no': 1, 'url': '/feedback', 'text': 'Feedback' },
    { 'no': 2, 'url': '/repairprice', 'text': 'RepairPrice' },
    { 'no': 3, 'url': '/scheduling', 'text': 'Scheduling' },
    { 'no': 4, 'url': '/invoicing', 'text': 'Invoicing' },
    { 'no': 5, 'url':'/add_value','text':'Add/Deduct Value'},
    { 'no': 6, 'url': '/show_score', 'text': 'Add Stars' },
    { 'no': 7, 'url': '/admins-ips', 'text': 'Ip Address' },
  ];
  footerDataDown = [
    { 'no': 8, 'url': '/inventory', 'text': 'Inventory' },
    { 'no': 9, 'url': '/repair', 'text': 'Repair Process' },
    { 'no': 10, 'url': '/add-product', 'text': 'Add Product' },
    { 'no': 11, 'url': '/home-mass', 'text': 'Search' },
    { 'no': 12, 'url': '/search2', 'text': 'Search2' },
    { 'no': 13, 'url':'/add-client','text':'Client'},
  ];
  isLogin = 0;
  isFooterDown = 1;
  isFooterUp = 0;
  userType: any;

  constructor(private local:LocalServiceService) { }

  ngOnInit(): void {
    
    let user_data = this.local.getUser();
    const { userType } = this.local.getUser();
    this.userType = userType;

    (user_data) ? this.isLogin = 1 : this.isLogin;
  }

  showAllFooter() {
    this.isFooterDown = 0;
    this.isFooterUp = 1;
  }

  showSomeFooter() {
    this.isFooterDown = 1;
    this.isFooterUp = 0;
  }

}
